import { createFocusTrap, FocusTrap } from 'focus-trap'
import { useEffect, useRef } from 'react'

import { useProjectContext } from 'services/Store/Project/hooks'
import { getSidebar } from 'services/Store/Project/selectors'

const useSidebarFocusManagement = (isDrawer: boolean) => {
  const { open: isSidebarOpen } = useProjectContext(getSidebar)
  const trapRef = useRef<FocusTrap | null>(null)
  const headerRef = useRef<HTMLDivElement>(null)
  const sidebarRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!isDrawer || !headerRef.current || !sidebarRef.current) {
      return
    }

    if (!isSidebarOpen) {
      trapRef.current?.deactivate()
      trapRef.current = null
      return
    }

    trapRef.current = createFocusTrap([headerRef.current, sidebarRef.current], {
      escapeDeactivates: true,
      clickOutsideDeactivates: true,
      returnFocusOnDeactivate: true,
      initialFocus: headerRef.current,
    })

    trapRef.current.activate()

    return () => {
      trapRef.current?.deactivate()
    }
  }, [isDrawer, isSidebarOpen, headerRef, sidebarRef])

  return { headerRef, sidebarRef }
}

export default useSidebarFocusManagement
